<template lang="pug">
	div
		deliveryFilter
		NothingFound(v-if="!filteredPpnts.length" text="Участников не найдено!")
		b-list-group(v-else)
			b-list-group-item.flex-column.align-items-start(v-for="ppnt in filteredPpnts" :key="ppnt.id")
				div.g-between-center.w-100
					div
						h5.mb-1
							span(v-html="fullName(ppnt.user||ppnt.dependent_member)") {{ fullName(ppnt.user||ppnt.dependent_member) }}
							span.ml-2 {{ timeLeft(ppnt.delivered_datetime) }}
						small(v-if="ppnt.user")
							div(v-if="ppnt.user.company")  {{ ppnt.user.company.title }}
							div(v-else-if="ppnt.user.organisation")  {{ ppnt.user.organisation }}
						div
							b-badge(variant="primary" style="font-weight:400;") {{ ppnt.stage.title }}

					div
						b-button.mr-2(variant="primary" size="sm" :disabled="downloadArr.includes(ppnt.id)" @click="download(ppnt)")
							b-spinner(small label="Small Spinner" v-if="downloadArr.includes(ppnt.id)")
							i.fa.fa-file-pdf-o.fa-md(v-else)
						b-button(variant="danger" size="sm" :disabled="removeArr.includes(ppnt.id)" @click="remove(ppnt.id)")
							b-spinner(small label="Small Spinner" v-if="removeArr.includes(ppnt.id)")
							i.fa.fa-close.fa-md(v-else)
</template>

<script>
	import { mapState } from 'vuex';
	import deliveryFilter from '../components/deliveryFilter';
	import forceFileDownload from '@/MIXINS/forceFileDownload'

	export default {
		name: 'DeliveryEvent',
		components: {
			deliveryFilter,
		},
		mixins: [
			forceFileDownload,
		],
		data: () => ({
			removeArr:[],
			downloadArr: [],
			fields:['id','user','dependent_member','reception_letter','reception_number','stage','attended','incomplete','delivered','delivered_datetime','denied']
		}),
		computed: {
			...mapState(['page','event']),
			...mapState({
				participants: state => state.event.participants,
			}),
			filterVal(){ return this.page.participant.filterDelivery.name },
			ppntsList(){
				return (this.participants.data || [])
			},
			ppntsComplete(){
				return this.ppntsList.filter(({attended, incomplete, delivered})=>(attended && (incomplete || delivered)))
			},
			filteredPpnts(){
				return this.filterVal
					? this.ppntsComplete.filter( ({user,dependent_member}) => {
						const {first_name,last_name,patronymic} = user || dependent_member;
						return (
							this.isSubStr(first_name,this.filterVal)
							|| this.isSubStr(last_name,this.filterVal)
							|| this.isSubStr(patronymic,this.filterVal)
						)
					}) : this.ppntsComplete;
			}
		},
		methods: {
			isSubStr(str, substr){ return (str ? (str.toLowerCase()).includes(substr.toLowerCase()) : false) },
			timeLeft(time){
				const timeLeft = new Date(1000*60*10 - ((new Date()).getTime() - (new Date(time)).getTime()));
				if ( timeLeft >= 0 ){
					const min = (timeLeft.getMinutes()+'').length === 1 ? '0'+timeLeft.getMinutes() : timeLeft.getMinutes();
					const sec = (timeLeft.getSeconds()+'').length === 1 ? '0'+timeLeft.getSeconds() : timeLeft.getSeconds();
					return min + ':' + sec
				} else {
					return 'expired';
				}
			},
			fullName({last_name,first_name,patronymic}){ return `${last_name} ${first_name} ${patronymic}` },
			remove(id){
				this.removeArr.push(id);
				this.$store.dispatch('patchParticipant', { id:id, data:{"incomplete":false,"delivered":false,"delivered_datetime":null,}} )
					.then( async () => {
						await this.$store.dispatch('getEventParticipants',{id:this.$route.params.id,params:{fields:this.fields}})
						await this.removeArr.splice(this.removeArr.indexOf(id),1);
					})
					.catch( error => alert(error) );
			},
			makeToast(append=false, msg='default text', variant='info', noHide=false) {
				this.$bvToast.toast([msg], {
					title: 'Центр уведомлений',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 2000,
					appendToast: append,
					variant: variant,
					noAutoHide: noHide
				})
			},
			getPDFName(ppnt){
				return `${this.fullName(ppnt.user||ppnt.dependent_member)}_schedule_(${this.event.data.title})`;
			},
			download(ppnt){
				this.downloadArr.push(ppnt.id);
				this.$store.dispatch('downloadSchedule',{id:ppnt.id})
					.then(async resp=>{
						if ( !resp || !resp.ok ) throw resp.body;

						await this.forceFileDownload(resp.data, this.getPDFName(ppnt));
						await this.downloadArr.splice(this.downloadArr.indexOf(ppnt.id),1);
					})
					.catch(async err=>{
						await this.downloadArr.splice(this.downloadArr.indexOf(ppnt.id),1);
						await this.makeToast(null, err.statusText || 'Произошла ошибка! Проверьте интернет соединение или попробуйте повторить попытку позднее!', 'danger');
					})
			},
		},
	}
</script>

